import { Handshake } from "@phosphor-icons/react";
import { t } from "i18next";

import { AddTeacherForm } from "@/components/Meditations";
import type { ModalProps } from "@/shared.types";
import { Circle, Heading, Modal } from "@/ui";

export const AddTeacherModal = ({ show, onClose }: ModalProps) => {
  return (
    <Modal
      show={show}
      title={
        <div className="flex flex-col gap-y-2">
          <Heading
            containerClassName="items-center"
            heading={t("collaborators.teachers.add_a_new_teacher")}
            left={
              <Circle>
                <Handshake size={24} className="text-tertiary-800" />
              </Circle>
            }
          />
          <span className="text-base text-neutral-700">
            *{t("error.required_fields")}
          </span>
        </div>
      }
      onClose={onClose}
    >
      <AddTeacherForm onClose={onClose} />
    </Modal>
  );
};
